import { render, staticRenderFns } from "./BsiContinuousFilingDetails.vue?vue&type=template&id=8233dc2e&scoped=true&"
import script from "./BsiContinuousFilingDetails.vue?vue&type=script&lang=js&"
export * from "./BsiContinuousFilingDetails.vue?vue&type=script&lang=js&"
import style0 from "./BsiContinuousFilingDetails.vue?vue&type=style&index=0&id=8233dc2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8233dc2e",
  null
  
)

export default component.exports